import { createContext, useContext, useEffect, useState } from "react";

const AccessibilityContext = createContext(null);

export function AccessibilityProvider({ children }) {
    const [textSize, setTextSize] = useState(() => localStorage.getItem("ds_text_size") || "normal");

    useEffect(() => {
        localStorage.setItem("ds_text_size", textSize);
        // Scale root font: normal = 16px, large = 19px (~+18%)
        document.documentElement.style.fontSize = textSize === "large" ? "19px" : "16px";
    }, [textSize]);

    return (
        <AccessibilityContext.Provider value={{ textSize, setTextSize }}>
            {children}
        </AccessibilityContext.Provider>
    );
}

export const useAccessibility = () => useContext(AccessibilityContext);
